<template>
    <div>
        <div class="banner">
            <div class="headerReplacementInformation"></div>
            <div class="banner-text">
                <b>{{ $t('information.title') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('information.breadcrumbHome') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('information.breadcrumbInfo') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('information.title') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <div class="TabMenu">
                <InformationTabMenu />
            </div>

            <div class="row mt-5">
                <div class="col-md-4 mb-3">
                    <div class="mb-5"><img src="../../assets/logo_origin_og.png"></div>
                    <div class="mb-3">
                        <h4><b>{{ $t('information.form.heading') }}</b></h4>
                    </div>
                    <div>{{ $t('information.form.phone') }} : 081-1311064</div>
                    <div>{{ $t('information.form.fax') }} : 02-3988066</div>
                    <div>{{ $t('information.form.email') }} : ir@origin.co.th</div>
                </div>

                <div class="col-md-8">
                    <div class="card border border-0 rounded-0">
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">{{ $t('information.form.firstname') }}*</label>
                                    <input v-model="form.name" type="text" class="form-control"
                                        :placeholder="$t('information.form.placeholder.firstname')" />
                                    <span v-if="errorMessage.name" class="text-danger">{{ errorMessage.name }}</span>
                                </div>
                                <div class="col-md">
                                    <label class="form-label">{{ $t('information.form.lastname') }}*</label>
                                    <input v-model="form.surname" type="text" class="form-control"
                                        :placeholder="$t('information.form.placeholder.lastname')" />
                                    <span v-if="errorMessage.surname" class="text-danger">{{ errorMessage.surname }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">{{ $t('information.form.tel') }}*</label>
                                    <input v-model="form.phone" type="text" class="form-control"
                                        :placeholder="$t('information.form.placeholder.tel')" />
                                    <span v-if="errorMessage.phone" class="text-danger">{{ errorMessage.phone }}</span>
                                </div>
                                <div class="col">
                                    <label class="form-label">{{ $t('information.form.faxinput') }}*</label>
                                    <input v-model="form.fax" type="text" class="form-control"
                                        :placeholder="$t('information.form.placeholder.fax')" />
                                    <span v-if="errorMessage.fax" class="text-danger">{{ errorMessage.fax }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">{{ $t('information.form.address') }}*</label>
                                    <input v-model="form.address" type="text" class="form-control" />
                                    <span v-if="errorMessage.address" class="text-danger">{{ errorMessage.address }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">{{ $t('information.form.details') }}</label>
                                    <textarea v-model="form.message" class="form-control"
                                        :placeholder="$t('information.form.placeholder.details')" rows="3"></textarea>
                                    <span v-if="errorMessage.message" class="text-danger">{{ errorMessage.message }}</span>
                                </div>
                            </div>
                            <div class="d-grid gap-2 col-4 mx-auto">
                                <button @click="save" class="btn btn-primary" type="button">{{ $t('information.form.submit')
                                }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import InformationTabMenu from '@/components/InformationTabMenu.vue';
import { GET_CONTACT_INVESTOR } from "@/store/actions.type";
import store from "@/store";
import Swal from "sweetalert2/src/sweetalert2.js";

export default {
    name: 'Info',
    components: {
        InformationTabMenu,
    },
    data() {
        return {
            form: {
                name: '',
                surname: '',
                phone: '',
                fax: '',
                address: '',
                message: ''
            },
            errorMessage: {},
        };
    },
    methods: {
        validateForm(form) {
            let errors = {};
            if (!form.name) errors.name = this.$t('information.form.error.firstname');
            if (!form.surname) errors.surname = this.$t('information.form.error.lastname');
            if (!form.phone || !/^\d{10}$/.test(form.phone)) errors.phone = this.$t('information.form.error.tel');
            if (!form.fax || !/^\d{9,10}$/.test(form.fax)) errors.fax = this.$t('information.form.error.fax');
            if (!form.address) errors.address = this.$t('information.form.error.address');
            if (!form.message) errors.message = this.$t('information.form.error.details');
            return Object.keys(errors).length > 0 ? errors : null;
        },
        async save() {
            let errorMessage = this.validateForm(this.form);
            if (errorMessage) {
                this.errorMessage = errorMessage;
                return;
            } else {
                this.errorMessage = {};
            }

            try {
                const response = await store.dispatch(GET_CONTACT_INVESTOR, { ...this.form });
                if (response === 'Email sent successfully') {
                    Swal.fire({
                        text: this.$t('information.form.success'),
                        icon: 'success',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: this.$t('information.form.submit'),
                    });
                    this.form = {};
                } else {
                    Swal.fire({
                        text: this.$t('information.form.fail'),
                        icon: 'error',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: this.$t('information.form.submit'),
                    });
                }
            } catch (error) {
                Swal.fire({
                    text: this.$t('information.form.errorprocessing'),
                    icon: 'error',
                    confirmButtonColor: "#E87D2E",
                    confirmButtonText: this.$t('information.form.submit'),
                });
            }
        },
    },
};
</script>
  
  
<style scoped>
h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    margin-left: 30px;
    height: 40%;
    margin-top: 10px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.text-danger {
    font-size: 12px;
    color: red;
}</style>
  